var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.borderShow > 0
    ? _c(
        "button",
        {
          staticClass:
            "button button_theme_content-width button_theme_light button_theme_stroke",
          on: { click: _vm.changePage }
        },
        [_vm._v("\n    Показать еще\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }